<div v-if="shouldRenderConfig && showButton" v-bind:class="getClassName">
    <button type="button" class="btn btn-primary" v-on:click="quotationButton" v-bind:class="getDisableClass">
        {{ $t(name) }}
    </button>
</div>
